/* TENSO — quiet scroll reveal.
   Used by the benefits band and the fiber pillars. Idempotent, and re-runs on
   shopify:section:load so it survives theme-editor section reloads. */
(function(){
  "use strict";
  var GRIDS='.benefits, .fiber-pillars__grid';
  var ITEMS='.benefit, .fiber-pillar';
  var observers=[];        /* held so an observer is never garbage-collected */

  function init(){
    var grids=document.querySelectorAll(GRIDS);
    if(!grids.length) return;
    if(!('IntersectionObserver' in window)) return; // no observer: items stay visible
    grids.forEach(function(grid){
      if(grid.dataset.revealBound) return;
      grid.dataset.revealBound='1';
      grid.classList.add('js-reveal');
      /* Fires a little BEFORE the item reaches the viewport (positive bottom
         rootMargin) and at a low threshold, so on a phone the settle has already
         begun by the time the card is actually looked at. */
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },{threshold:0.05,rootMargin:'0px 0px 12% 0px'});
      observers.push(io);
      grid.querySelectorAll(ITEMS).forEach(function(b){io.observe(b);});

      /* Safety floor: nothing may stay invisible because an observer misfired. */
      setTimeout(function(){
        grid.querySelectorAll(ITEMS).forEach(function(b){b.classList.add('is-in');});
      },2500);
    });
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
